import { useCallback } from 'react';
import { isBrowserAuthConnection } from 'vet-bones/utils';

import { connectionSelector } from 'src/selectors/connection';
import { isConnectedSelector } from 'src/selectors/isConnected';
import { isConnectingSelector } from 'src/selectors/isConnecting';
import { ConnectionStatus } from 'src/store/connections/types';
import { ReduxState } from 'src/store/types';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const useEnsureConnection = () => {
  const dispatch = useReduxDispatch();
  const isConnected = useReduxSelector(isConnectedSelector);
  const isConnecting = useReduxSelector(isConnectingSelector);
  const connectionStatus = useReduxSelector(
    (state: ReduxState) => state.connections.status
  );
  const connection = useReduxSelector(connectionSelector);
  const isConnectionPending =
    isConnecting || connectionStatus === ConnectionStatus.PENDING;
  const isDisconnected =
    connectionStatus === ConnectionStatus.SIGNED_OUT ||
    connectionStatus === ConnectionStatus.FAILURE;

  const ensureConnection = useCallback((): boolean => {
    if (isConnected || isConnectionPending) {
      return true;
    }
    if (connection && isBrowserAuthConnection(connection)) {
      dispatch(uiSlice.actions.openedBrowserAuthFailedDialog());
    } else {
      dispatch(uiSlice.actions.openedSignInDialog());
    }
    return false;
  }, [dispatch, isConnected, isConnectionPending, connection]);

  return { isConnected, isConnectionPending, isDisconnected, ensureConnection };
};
